export default "__VITE_ASSET__DFZDyOua__"